import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { ChangeSetUpdatePayload } from 'src/features/locations/scheduleComponentPage/ScheduleComponentPage.interface';
import { queryKeys, requestCCApi } from 'src/utils';

export const useUpdateChangeSet = () => {
  return useMutation({
    mutationFn: async ({
      changeSetId,
      payload,
    }: {
      changeSetId: number;
      payload: ChangeSetUpdatePayload;
    }) => {
      const response = await requestCCApi({
        url: `/changeSets/${changeSetId}`,
        method: 'PATCH',
        data: { data: payload },
      });

      return response;
    },
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.schedulePreview.invalidateAll());
    },
  });
};
